import { IIcon } from './iconConstants'
export default function LanguageIcon({ width, height }: IIcon) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.001 21.6a9.6 9.6 0 1 1 0-19.2 9.6 9.6 0 0 1 0 19.2zm-2.198-2.24a17.184 17.184 0 0 1-1.615-6.4H4.38a7.688 7.688 0 0 0 5.422 6.4zm2.199.082a15.269 15.269 0 0 1-1.89-6.482h3.78a15.27 15.27 0 0 1-1.89 6.482zm7.62-6.482h-3.807a17.183 17.183 0 0 1-1.615 6.4 7.688 7.688 0 0 0 5.422-6.4zM8.188 11.04H4.38a7.688 7.688 0 0 1 5.422-6.4 17.184 17.184 0 0 0-1.615 6.4zm5.704 0a15.269 15.269 0 0 0-1.89-6.482 15.269 15.269 0 0 0-1.89 6.482h3.78zm1.923 0a17.184 17.184 0 0 0-1.615-6.4 7.688 7.688 0 0 1 5.422 6.4h-3.807z'
        fill='#666'
      />
    </svg>
  )
}
